module.exports = __webpack_public_path__ + "static/ozow-brand-logo-47a7419c41f8696163f0c7f619b4dc09.png";